/**
 * @module route/parser
 */
'use strict';

/** Wrap the compiled parser with the context to create node objects */
var parser = require('./compiled-grammar').parser;
parser.yy = require('./nodes');
module.exports = parser;



//////////////////
// WEBPACK FOOTER
// ./node_modules/route-parser/lib/route/parser.js
// module id = 1648
// module chunks = 100 101